<template>
  <div>
    <div class="sga-page-1 page-1">
      <h2>Hello {{ employeeName }}</h2>
      <br />
      <p>
        <strong
          >The types of questions covered in this section tells us about you and
          the skills you have:
          <ul>
            <li>including your hidden talents</li>
            <li>previous key roles</li>
          </ul>
          If you wish to learn more about what happens with your data,
          <span @click="viewPrivacyPolicy()">click here</span>
        </strong>
      </p>
      <br />
      <el-form @submit.native.prevent="storeSection">
        <label role="text"
          >Upload a photo for your profile <i>(Optional)</i></label
        >
        <div class="ts-upload flexed">
          <el-upload
            class="upload-small"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            :file-list="fileList"
            :on-change="uploadImage"
            :show-file-list="false"
            :auto-upload="false"
            multiple
          >
            <i class="el-icon-camera"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
          </el-upload>

          <div v-if="base64Raw === 'na'" class="card-container-sga">
            <span v-if="base64Raw === 'na'">
              <img
                src="~../../../../assets/img/avatar_dummy_profile.svg"
                class="card-img-sga"
                id="img-up"
              />
            </span>
          </div>
          <el-tooltip
            v-else
            content="Click image to remove photo"
            placement="top"
          >
            <el-badge is-dot class="item">
              <div class="card-container-sga">
                <span v-if="base64Raw !== 'na'">
                  <img
                    :src="this.base64Raw"
                    class="card-img-sga"
                    @click="removePhoto"
                  />
                </span>
              </div>
            </el-badge>
          </el-tooltip>
        </div>
        <el-alert
          v-if="exceeded"
          :title="uploadErr"
          type="error"
          :closable="false"
          show-icon
        >
        </el-alert>
        <el-alert
          title="JPG/PNG files with a size less than 2000kb (2mb)"
          type="warning"
          :closable="false"
          show-icon
        >
        </el-alert>

        <input id="b64" hidden />

        <label role="text">Please confirm your email address in the box below</label>
        <el-form-item :error="confirmEmailAddressError" :required="true">
          <el-input
            placeholder=""
            v-model="sgaEmployeeInfo.confirmEmailAddress"
          ></el-input>
        </el-form-item>

        <label role="text">Please confirm your personal email address in the box below</label>
        <el-form-item :error="personalEmailAddressError" :required="true">
          <el-input
            placeholder=""
            v-model="sgaEmployeeInfo.personalEmailAddress"
          ></el-input>
        </el-form-item>

        <label role="text"
          >Please confirm your birth date</label
        >
        <el-form-item
          :error="birthDateError"
          :required="true"
        >
          <el-date-picker
            v-model="sgaEmployeeInfo.birthDate"
            type="date"
            placeholder="Pick a date"
          >
          </el-date-picker>
        </el-form-item>


        <label role="text">Please confirm your telephone number in the box below</label>
        <el-form-item :error="telephoneNumberError" :required="true" >
          <el-input
            type="TelephoneNumber"
            placeholder=""
            v-model="sgaEmployeeInfo.telephoneNumber"
          ></el-input>
        </el-form-item>

        <label role="text">Please confirm your zip code</label>
        <el-form-item :error="zipCodeError" :required="true">
          <el-input placeholder="" v-model="sgaEmployeeInfo.zipCode"></el-input>
        </el-form-item>

        <label role="text"
          >What is your current or last salary in your previous job?</label
        >
        <el-form-item :error="employeeSalaryError" :required="true">
          <div style="display: flex" class="el-input">
            <currency-input
              v-model="convertedSalary"
              :decimal-length="0"
              :currency="selectedCurrency"
              style="width: 200px"
              class="el-input__inner"
            />
            <el-select
              style="margin-left: 5px; width: 200px"
              v-model="selectedFrequency"
              filterable
              placeholder="Yearly"
            >
              <el-option
                v-for="item in salaryFrequencies"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <div
          style="background: #edf2fa"
          :xl="24"
          :lg="24"
          :md="24"
          :sm="24"
          :xs="24"
        >
          <div style="padding: 10px">
            <el-row>
              <label role="text" style="font-weight: bold"
                >What is your current or previous job title?
                <el-tooltip class="item" effect="dark" placement="top">
                  <div slot="content">
                    Help find your job role title by entering key words<br />
                    to search our system.
                  </div>
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </el-tooltip>
              </label>
              <span style="font-style: italic; font-size: 12px"
                >(Search with keywords and click search icon at the right side
                or tick checkbox below if you don't have any)</span
              >

              <el-col :xs="24" :md="24" :lg="24">
                <div>
                  <el-form-item
                    :error="
                      retrieveFieldError(
                        modelState,
                        'Request.SgaEmployeeInfo.EmployeeRoleTitle'
                      )
                    "
                    :required="true"
                  >
                    <el-input
                      type="text"
                      v-model="keyword"
                      @keyup.enter.native="search"
                      placeholder="Search your current or previous job titles.."
                    >
                      <el-button
                        slot="append"
                        icon="el-icon-search"
                        @click="search"
                      ></el-button>
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>

          <div style="padding-right: 20px">
            <el-row>
              <br />
              <el-col :span="23" :offset="1">
                <label role="text" style="font-size: 12px; font-weight: bold"
                  >Select a job title that is most applicable to you</label
                >
                <span style="font-style: italic; font-size: 10px"
                  >(Add up to 3 job titles to add your skills to your
                  profile)</span
                >
                <el-form-item>
                  <div
                    style="
                      width: 100%;
                      height: 580px;
                      background-color: white;
                      overflow: auto;
                    "
                  >
                    <div
                      v-for="(job, index) in jobAltTitles"
                      :key="index"
                      class="ts-comp--multiselect-item alt-titles"
                      style="border: none"
                    >
                      <el-checkbox
                        ref="AltTitle"
                        class="handleAltCheckbox"
                        @change="handleAltCheckbox($event, job.Code, job.Title)"
                        style="height: auto; text-align: left"
                        >{{ job.Title }}</el-checkbox
                      >
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div style="padding: 10px">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    style="padding-left: 5px"
                    placement="top-start"
                  >
                    <div slot="content">
                      <span style="font-weight: bold"
                        >Job Titles from current and prior jobs</span
                      >
                    </div>
                    <label role="text"
                      >Your official job role title &nbsp;
                      <i class="fas fa-question-circle"></i
                    ></label>
                  </el-tooltip>
                  <el-form-item :error="employeeRoleTitleError" :required="true">
                    <div>
                      <div
                        v-for="(title, index) in roleTitles"
                        :key="index"
                        style="display: inline-block; margin-right: 20px"
                      >
                        <i
                          class="el-icon-remove"
                          v-if="title != ''"
                          style="color: #dc3c3c; font-size: 20px"
                          @click="handleAltCheckbox(false, null, title.trim())"
                        ></i>
                        &nbsp;&nbsp;{{ title.trim() }}
                      </div>
                      <input
                        type="hidden"
                        v-model="sgaEmployeeInfo.employeeRoleTitle"
                        readonly
                        id="roleTitle"
                      />
                    </div>
                  </el-form-item>
                  <el-alert
                    v-if="JobRoleCountError"
                    title="Select 3 or less job titles"
                    type="error"
                    show-icon
                    :closable="false"
                    style="width: 500px; margin-top: 10px"
                  ></el-alert>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <el-alert
          v-if="hasError"
          title="Please make sure all the required fields are filled in correctly."
          type="error"
          show-icon
          :closable="false"
          style="width: 500px; margin-top: 10px"
        ></el-alert>

        <div style="padding-top: 20px">
          <el-button
            class="ts-btn ts-btn-rounded ts-btn-secondary"
            @click="storeSection"
            >Continue</el-button
          >
        </div>
      </el-form>
      &nbsp;
    </div>

    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
    <questionnaire-print
      ref="questionnaire"
      :page1="page1"
      :page2="page2"
      :page3="page3"
      :page4="page4"
      :page5="page5"
      :page6="page6"
      :page7="page7"
      :page8="page8"
      :page9="page9"
      :page10="page10"
      :page11="page11"
      :page12="page12"
      currentPage="page1"
    > 
    </questionnaire-print>
    <JobSeekerCV
      ref="cv"
      :Data="profile.survey"
      :profile="profile"
      :Image="base64Raw"
      :UserInfo="currentUser"
      :ShowProfile="false"
    />
    <ResumeListSelection
      :ProfileSettings="profileSettings"
      :ShowControl="showResumeListModal"
      @close-control="closeResumeListModal"
      @show-resume="displayResume"
    />
    <ImageCropperModal
      :imgToCrop="image"
      :bucketType="bucketType"
      :objectId="objectId"
      :ShowImageCropper="showImageCropper"
      @close-cropper="onCloseDialog"
      @imageUploading="setImageValue"
    />
    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import dataDelimiter from "@/utils/data.utils";
import dateUtils from "@/utils/date.utils";
import QuestionnairePrint from "../../components/QuestionnairePrint.vue";
import JobSeekerCV from "../../components/JobSeekerCV";
import TSLoading from "../../../../components/TSLoading.vue";
import ResumeListSelection from "../../components/ResumeListSelection.vue";
import ImageCropperModal from "./ImageCropperModal.vue";
import { BucketType } from "@/enums";

export default {
  components: {
    QuestionnairePrint,
    JobSeekerCV,
    TSLoading,
    ResumeListSelection,
    ImageCropperModal
  },
  created() {
    this.isLoading = true;
    this.$store.dispatch("organisation/getExchangeRates").then(res => {
      this.$ExchangeRates = res;

      // TODO: Uncomment this
      this.selectedLocale =
        localStorage.getItem("locale") || this.selectedLocale;
      this.selectedCurrency = this.$i18n.messages[
        localStorage.getItem("locale")
      ].currency;
      this.$store
        .dispatch("sga/getsga")
        .then(res => {
          if (res.sgaEmployeeInfo != null) {
            this.sgaEmployeeInfo = res.sgaEmployeeInfo;
          } else {
            this.sgaEmployeeInfo = this.currentSga.sgaEmployeeInfo;
          }

          if (this.currentUser?.birthDate != null && this.sgaEmployeeInfo?.birthDate == null) {
            this.$set(this.sgaEmployeeInfo, 'birthDate', this.currentUser.birthDate);
          }

          if (this.currentUser?.phoneNumber != null && this.sgaEmployeeInfo?.telephoneNumber == null) {
            this.$set(this.sgaEmployeeInfo, 'telephoneNumber', this.currentUser.phoneNumber);
          }

          this.sgaYourJob = res.sgaYourJob;

          if (
            this.sgaEmployeeInfo &&
            this.sgaEmployeeInfo.employeeRoleONETCode != undefined
          ) {
            this.fetchJobLevels(this.sgaEmployeeInfo.employeeRoleONETCode);

            let jobLevel = {
              value:
                res.sgaEmployeeInfo != undefined
                  ? res.sgaEmployeeInfo.employeeRoleTitleLevel
                  : null,
              data: {
                Code:
                  res.sgaEmployeeInfo != undefined
                    ? res.sgaEmployeeInfo.employeeRoleONETCode
                    : null
              }
            };
            this.handleJobLevelSelected(jobLevel);
          }

          this.selectedFrequency =
            this.sgaEmployeeInfo.employeeSalaryFrequency || 0;
          if (this.sgaEmployeeInfo.salaryCurrency) {
            this.salaryCurrency = this.sgaEmployeeInfo.salaryCurrency;
          } else {
            this.salaryCurrency = "USD";
          }

          if (this.sgaEmployeeInfo.employeeSalary != null) {
            // this.convertedSalary = Number(this.sgaEmployeeInfo.employeeSalary) * this.$ExchangeRates.filter((r) => r.Base == this.salaryCurrency)[0].Rates[this.selectedCurrency];
            this.convertedSalary =
              Number(this.sgaEmployeeInfo.employeeSalary) *
              this.$ExchangeRates[0].rates[this.selectedCurrency];
          }

          if (this.sgaEmployeeInfo.employeeRoleTitle == "N/A") {
            this.NoPreviousJob = true;
            this.toggleNoPreviousJob();
          } else this.noPreviousJob = false;

          if (
            res.sgaEmployeeInfo != null &&
            res.sgaEmployeeInfo.employeeRoleTitleCodeSequence == "" &&
            res.sgaEmployeeInfo.employeeRoleOnetCode != null
          ) {
            //means old data, need to fetch the code sequence
            let obj = {};
            obj.ONETCodes = res.sgaEmployeeInfo.EmployeeRoleONETCode.split(",");
            this.getRoleTitleSequence(obj);
          }

          if (
            this.sgaEmployeeInfo.employeeRoleTitle != "" &&
            this.sgaEmployeeInfo.employeeRoleTitle != null
          ) {
            const roleTitle = this.sgaEmployeeInfo.employeeRoleTitle || "";
            this.roleTitles = roleTitle.split(dataDelimiter);
          }
          else this.roleTitles = [];
          
          this.isLoading = false;
        })
        .catch(() => {
          this.sgaEmployeeInfo = this.currentSga.sgaEmployeeInfo;
          this.selectedFrequency =
            this.sgaEmployeeInfo.employeeSalaryFrequency || 0;
          this.salaryCurrency = "USD";
          this.noPreviousJob = false;
          this.roleTitles = [];
          this.isLoading = false;

          if (this.currentUser?.birthDate != null && this.sgaEmployeeInfo?.birthDate == null) {
            this.$set(this.sgaEmployeeInfo, 'birthDate', this.currentUser.birthDate);
          }

          if (this.currentUser?.phoneNumber != null && this.sgaEmployeeInfo?.telephoneNumber == null) {
            this.$set(this.sgaEmployeeInfo, 'telephoneNumber', this.currentUser.phoneNumber);
          }
        });

      const selectedBucketType = this.isApprentice
        ? BucketType.Apprentice
        : BucketType.Jobseeker;

      this.$store
        .dispatch("common/getImage", {
          objectId: this.currentUser.id,
          bucketType: selectedBucketType
        })
        .then(b64UserImg => {
          if (b64UserImg) {
            this.base64Raw = b64UserImg;
          } else {
            this.base64Raw = "na";
          }

          sessionStorage.removeItem("profilephoto");
          sessionStorage.setItem("profilephoto", this.base64Raw);

          this.$store.dispatch("onet/jobDescriptionsTest").then(res => {
            this.jobTitleOptions = res;
          });

          sessionStorage.setItem(
            "sgaDataForPrinting",
            JSON.stringify({
              page1: {
                sgaEmployeeInfo: this.currentSga.sgaEmployeeInfo,
                jobs: this.jobs,
                jobTitleSelected: this.jobTitleSelected,
                jobTitleOptions: this.jobTitleOptions,
                jobAltTitles: this.jobAltTitles,
                showNoData: this.showNoData,
                selectedFrequency: this.selectedFrequency,
                salaryFrequencies: this.salaryFrequencies,
                base64Raw: this.base64Raw,
                exceeded: this.exceeded
              }
            })
          );
        });
    });
  
  },
  updated() {
    for (const a of document.getElementsByClassName("el-upload__input")) {
      a.style.display = "none";
    }
  },
  mounted() {
    this.$router.app.$on("questionnaire-print", this.printPage);
    // this.$router.app.$on('cv-print', this.printPageAsCV);
    this.$router.app.$on("show-resume-list", this.showResumeList);
  },
  destroyed() {
    if (
      this.$route.matched.find(c => c.path === "/sga/questionnaire") ===
      undefined
    ) {
      sessionStorage.removeItem("sgaDataForPrinting");
    } else {
      this.$router.app.$off("questionnaire-print", this.printPage);
      this.$router.app.$off("cv-print", this.printPageAsCV);
    }
  },
  data() {
    return {
      base64Raw: null,
      showResumeListModal: false,
      roleTitles: [],
      $ExchangeRates: null,
      NoPreviousJob: false,
      uploadErr: null,
      debugid: null,
      isLoading: false,
      roleLevelId: null,
      availableRoles: [],
      modelState: {},
      sgaEmployeeInfo: {
        usPriorityOfService: -1
      },
      availableAlternateTitles: [],
      fileList: [],
      b64Img: {},
      exceeded: false,
      showNoData: true,
      jobTitleOptions: [],
      jobTitleSelected: [],
      jobAltTitles: [],
      jobs: {
        jobTitles: []
      },
      onet: {
        ONETCodes: []
      },
      selected_onet: {
        ONETCodes: []
      },
      salaryFrequencies: [
        {
          value: 0,
          label: "Yearly"
        },
        {
          value: 1,
          label: "Monthly"
        },
        {
          value: 2,
          label: "Weekly"
        },
        {
          value: 3,
          label: "4 Weekly"
        },
        {
          value: 4,
          label: "2 Weekly"
        },
        {
          value: 5,
          label: "Daily"
        },
        {
          value: 6,
          label: "Hourly"
        }
      ],
      selectedFrequency: 0,
      sgaYourJob: {
        jobDescriptionTasks: []
      },
      taskSearch: null,
      hiddenTasks: [],
      sgaEducation: {
        secondLevelEducation: {
          highSchoolDiploma: false,
          ged: false,
          oLevels: false,
          oLevelDetails: [],
          leavingCert: false,
          aLevels: false,
          aLevelDetails: []
        },
        thirdLevelEducation: {
          associateDegree: false,
          associateDegreeDetails: [],
          bachelorsDegree: false,
          bachelorsDegreeDetails: []
        },
        fourthLevelEducation: {
          mastersDegree: false,
          mastersDegreeDetails: [],
          doctoralDegree: false,
          doctoralDegreeDetails: []
        },
        sectorExperience: {
          experience: false,
          experienceDetails: []
        },
        naicsLevel1Options: {}
      },
      sgaWorkHistory: {
        userWorkHistory: []
      },
      sgaHiddenExtras: {
        workingPracticeActivities: []
      },
      sgaKnowledge: {
        knowledgeRegularlyUsed: []
      },
      sgaMindset: {
        mindsets: []
      },
      sgaSkills: {
        workingPracticeSkills: []
      },
      sgaTechnologies: {
        selectedTechnologies: [],
        customTechnologies: []
      },
      sgaHiddenTalents: {
        skillsKnowledgeOutsideWork: []
      },
      sgaCulture: {
        selectedCultureOptions: [],
        commuteDistance: "",
        transportation: []
      },
      sgaCertifications: {
        userCertifications: []
      },
      selectedLocale: "en-US",
      showProfile: false,
      selectedCurrency: "USD",
      salaryCurrency: null,
      convertedSalary: null,
      selected_onet_label: null,
      keyword: null,
      profile: {},
      profileSettings: [],
      showImageCropper: false,
      image: "",
      bucketType: 0,
      objectId: "",
      confirmEmailAddressError: null,
      personalEmailAddressError: null,      
      usPriorityOfServiceError: null,
      zipCodeError: null,
      jobRoleCountError: false,
      telephoneNumberError: null,
      JobRoleCountError: false,
      employeeSalaryError: null,
      employeeRoleTitleError: null,
      birthDateError: null,
      hasError: false,
    };
  },
  watch: {
    "sgaEmployeeInfo.employeeRoleTitleLevel": function(
      newRoleLevelId,
      oldRoleLevelId
    ) {
      if (
        newRoleLevelId === undefined ||
        newRoleLevelId === null ||
        newRoleLevelId === oldRoleLevelId
      )
        return;

      this.availableRoles = [];
      this.roleLevelId = null;

      this.isLoadingSkills = true;

      // this.$store.dispatch('skills/all', this.skillCategoryId)
      //   .then(res => this.availableRoles = res)
      //   .finally(res => this.isLoadingSkills = false);
    }
  },
  computed: {
    toggleNoPreviousJob() {
      if (this.noPreviousJob) {
        this.sgaEmployeeInfo.employeeRoleTitleLevel = "N/A";
        this.sgaEmployeeInfo.employeeRoleTitle = "N/A";
        this.sgaYourJob = null;
        this.sgaEmployeeInfo.employeeRoleONETCode = null;
        this.handleClearMultiSelect();
      } else {
        this.sgaEmployeeInfo.employeeRoleTitleLevel = "";
        this.sgaEmployeeInfo.employeeRoleTitle = "";
        this.sgaEmployeeInfo.employeeRoleONETCode = "";
        this.sgaYourJob = this.currentSga.sgaYourJob;
      }
      this.currentSga.isComplete = false;
    },
    currentSga() {
      return this.$store.state.sga.current_sga;
    },
    currentUser() {
      return this.$store.state.account.current_user;
    },
    departments() {
      //return this.$store.state.organisation.current_organisation.Departments;
    },
    employees() {
      //return this.$store.state.organisation.current_organisation.Employees.filter(e => e.UserId !== this.currentUser.Id);
    },
    employeeName() {
      return this.$store.state.account.current_user.fullName;
    },
    isApprentice() {
      return this.$store.state.account.current_user.roles.includes(
        "Apprentice"
      );
    },
    page1() {
      return {
        sgaEmployeeInfo: this.sgaEmployeeInfo,
        jobs: this.jobs,
        jobTitleSelected: this.jobTitleSelected,
        jobTitleOptions: this.jobTitleOptions,
        jobAltTitles: this.jobAltTitles,
        showNoData: this.showNoData,
        selectedFrequency: this.selectedFrequency,
        salaryFrequencies: this.salaryFrequencies,
        base64Raw: this.base64Raw,
        exceeded: this.exceeded
      };
    },
    page2() {
      return {
        sgaYourJob: this.sgaYourJob,
        taskSearch: this.taskSearch,
        hiddenTasks: this.hiddenTasks
      };
    },
    page3() {
      return {
        sgaEducation: this.sgaEducation
      };
    },
    page4() {
      this.sgaWorkHistory.userWorkHistory.forEach(element => {
        if (element.workedFrom == "0001-01-01T00:00:00") {
          element.workedFrom = null;
        }
        if (element.workedTo == "0001-01-01T00:00:00") {
          element.workedTo = null;
        }
      });
      return {
        sgaWorkHistory: this.sgaWorkHistory
      };
    },
    page5() {
      this.sgaCertifications.userCertifications.forEach(element => {
        if (element.acquiredDt == "0001-01-01T00:00:00") {
          element.acquiredDt = null;
        }
        if (element.expirationDt == "0001-01-01T00:00:00") {
          element.expirationDt = null;
        }
        if (element.image == undefined) {
          element.image = null;
        }
      });
      return {
        sgaCertifications: this.sgaCertifications
      };
    },
    page6() {
      return {
        sgaHiddenExtras: this.sgaHiddenExtras
      };
    },
    page7() {
      return {
        sgaKnowledge: this.sgaKnowledge
      };
    },
    page8() {
      return {
        sgaTechnologies: this.sgaTechnologies
      };
    },
    page9() {
      return {
        sgaMindset: this.sgaMindset
      };
    },
    page10() {
      return {
        sgaSkills: this.sgaSkills
      };
    },
    page11() {
      return {
        sgaHiddenTalents: this.sgaHiddenTalents
      };
    },
    page12() {
      return {
        sgaCulture: this.sgaCulture
      };
    }
  },
  methods: {
    closeResumeListModal() {
      this.showResumeListModal = false;
    },
    onCloseDialog() {
      this.showImageCropper = false;
    },
    showResumeList() {
      this.$store
        .dispatch(
          "onlineprofile/getuserprofilepagesettings",
          this.currentUser.id
        )
        .then(res => {
          this.profileSettings = res.filter(d => d.isActive == true);
          this.loading = false;
          this.showResumeListModal = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    displayResume(setting) {
      let obj = {
        userid: this.currentUser.id,
        cvid: setting.id
      };
      this.$store.dispatch("account/getprofiledetails", obj).then(res => {
        this.profile = res;
        this.showProfile = this.profile?.configuration?.profileConfiguration?.personalInformation?.profilePhoto;
        this.closeResumeListModal();

        this.$refs.cv.showCV(true);
        // this.showProfile = true;
        this.$refs.questionnaire.hideQuestionnaire();
        let x = this.$refs.cv.hideCV;
        window.setTimeout(function() {
          // action();
          window.print();
          x();
        }, 500);
      });
    },
    isEmpty(obj) {
      if (obj?.base64Raw != "" && obj?.base64Raw != null) {
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) return false;
        }
        return true;
      } else if (obj.data != "" && obj.data != null) {
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) return false;
        }
        return true;
      } else {
        return true;
      }
    },
    viewPrivacyPolicy() {
      this.$router.push({ name: "ViewPrivacyPolicy" });
    },
    uploadImage(file) {
      if (file.raw.type == "image/png" || file.raw.type == "image/jpeg") {
        let fsize = file.size / 1024;
        if (fsize > 500) {
          this.uploadErr =
            "File size should be at least 500kb (.5mb) or lower!";
          this.exceeded = true;
        } else {
          this.bucketType = this.isApprentice
            ? BucketType.Apprentice
            : BucketType.Jobseeker;
          this.objectId = this.currentUser.id;
          this.showImageCropper = true;
          this.image = URL.createObjectURL(file.raw);
        }
      } else {
        this.uploadErr = "Image should be in PNG or JPG format!";
        this.exceeded = true;
      }
    },
    setImageValue(selectedImageValue) {
      if (this.isEmpty(selectedImageValue)) {
        this.base64Raw = "na";
      } else {
        this.base64Raw = selectedImageValue.base64Raw;
      }
      sessionStorage.removeItem("profilephoto");
      sessionStorage.setItem("profilephoto", this.base64Raw);
      this.showImageCropper = false;
    },
    getAlternateTitles(code) {
      axios
        .get(
          `${process.env.VUE_APP_API_BASE_URI}onet/alternateTitlesByCode?onetCode=${code}`
        )
        .then(res => {
          this.availableAlternateTitles = res.map(a => ({
            value: a.Title,
            data: a
          }));
        });
    },
    getDescriptionTitles(querySearch, callback) {
      if (!querySearch || querySearch.length < 3) {
        callback([]);
        return;
      }
      axios
        .get(
          `${process.env.VUE_APP_API_BASE_URI}onet/jobDescriptions?searchQuery=${querySearch}`
        )
        .then(res => {
          callback(res.map(a => ({ value: a.Title, data: a })));
        });
    },
    handleAlternateTitleSelected(alternateTitle) {
      this.sgaEmployeeInfo.employeeRoleTitle = alternateTitle.data.title;
      this.sgaEmployeeInfo.employeeRoleONETCode = alternateTitle.data.code;
      this.fetchJobLevels(alternateTitle.data.Code);
    },
    fetchJobLevels(onetCode) {
      axios
        .get(`${process.env.VUE_APP_API_BASE_URI}onet/jobDescriptions`)
        .then(res => {
          this.$store.dispatch("sga/setJobDescriptions", res);
        });
    },
    getJobLevels(querySearch, callback) {
      const filtered = querySearch
        ? this.$store.state.sga.jobDescriptions
        : this.$store.state.sga.jobDescriptions.filter(
            j => j.indexOf(querySearch) > -1
          );
      callback(filtered.map(j => ({ value: j })));
    },
    handleJobLevelSelected(jobLevel) {
      this.sgaEmployeeInfo.employeeRoleTitleLevel = jobLevel.value;
      this.sgaEmployeeInfo.employeeRoleONETCode = jobLevel.data.Code;
      this.getAlternateTitles(jobLevel.data.Code);
    },
    linkedInSection() {
      axios
        .get(
          `${process.env.VUE_APP_API_BASE_URI}linkedin/getLinkedInPhoto?url=${window.location.href}`
        )
        .then(res => {
          window.open(res, "_blank");
        });
    },
    storeSection(e) {
      e.preventDefault();
      this.isLoading = true;

      const roleTitle = this.sgaEmployeeInfo.employeeRoleTitle || "";

      if (roleTitle.split(dataDelimiter).length > 3) {
        this.JobRoleCountError = true;
        return false;
      } 

      else {
        this.hasError = false;

        this.zipCodeError = null;
        this.confirmEmailAddressError = null;
        this.personalEmailAddressError = null;
        this.telephoneNumberError = null;
        this.employeeSalaryError = null;
        this.employeeRoleTitleError = null;
        this.birthDateError = null;

        if (
          this.sgaEmployeeInfo.zipCode == null ||
          this.sgaEmployeeInfo.zipCode == ""
        ) {
          this.zipCodeError = "Zipcode fied is required.";
          this.hasError = true;          
        } 
        
        if (
          this.sgaEmployeeInfo.confirmEmailAddress == null ||
          this.sgaEmployeeInfo.confirmEmailAddress == ""
        ) {
          this.confirmEmailAddressError = "Email address field is required.";
          this.hasError = true;
        } 
        
        if (
          this.sgaEmployeeInfo.personalEmailAddress == null ||
          this.sgaEmployeeInfo.personalEmailAddress == ""
        ) {
          this.personalEmailAddressError = "Personal email address field is required.";
          this.hasError = true;
        }

        if (
          this.sgaEmployeeInfo.telephoneNumber == null ||
          this.sgaEmployeeInfo.telephoneNumber == ""
        ) {
          this.telephoneNumberError = "Telephone number field is required.";
          this.hasError = true;
        }

        if (this.convertedSalary == null || this.convertedSalary == "") {
          this.employeeSalaryError = "Employee salary field is required.";
          this.hasError = true;
        }

        if (
          this.sgaEmployeeInfo.employeeRoleTitle == null ||
          this.sgaEmployeeInfo.employeeRoleTitle == ""
        ) {
          this.employeeRoleTitleError = "Role title field is required.";
          this.hasError = true;
        }
        if (
        this.sgaEmployeeInfo.birthDate == null ||
        this.sgaEmployeeInfo.birthDate == ""
        ) {
          this.birthDateError = "Birth date field is required.";
          this.hasError = true;
        }
        
        else {
          this.isLoading = true;
          this.$store
            .dispatch(
              "common/validateUserZipCode",
              this.sgaEmployeeInfo.zipCode
            )
            .then(res => {
              if (res.postcodes[0] == null) {
                this.zipCodeError = `Please enter a valid zipcode.`;
                this.hasError = true;
                this.isLoading = false;
              } else {
                this.zipCodeError = null;
                this.sgaEmployeeInfo.origin = res.postcodes[0].countryCode;
                this.sgaEmployeeInfo.roleAvailability = "CLOSED";
                this.sgaEmployeeInfo.firstname = this.currentUser.firstname;
                this.sgaEmployeeInfo.surname = this.currentUser.surname;
                this.sgaEmployeeInfo.birthDate = dateUtils.formatDateToISOString(this.sgaEmployeeInfo.birthDate);

                if (!this.hasError) {
                  //re-evaluate sgaYourJob from selected role title
                  if (
                    this.sgaYourJob != null &&
                    this.sgaYourJob.jobDescriptionTasks.length > 0
                  ) {
                    let tempArray = [];
                    let codes =
                      this.sgaEmployeeInfo.employeeRoleONETCode.indexOf(",") >
                      -1
                        ? this.sgaEmployeeInfo.employeeRoleONETCode
                            .split(",")
                            .map(function(item) {
                              return item.trim();
                            })
                        : [this.sgaEmployeeInfo.employeeRoleONETCode];

                    codes.forEach(element => {
                      let res = this.sgaYourJob.jobDescriptionTasks.filter(
                        x => x.indexOf(element) > -1
                      );
                      if (res != null) tempArray.push(...res);
                    });

                    this.sgaYourJob.jobDescriptionTasks = tempArray;
                  }

                  sessionStorage.setItem("NavigateAwayFrom", "page1");
                  sessionStorage.setItem("UserId", this.currentUser.Id);
                  this.isLoading = true;
                  this.sgaEmployeeInfo.employeeSalary = this.convertedSalary.toString();
                  this.sgaEmployeeInfo.usPriorityOfService =
                    this.selectedLocale === "en-uk" ? null : 4;
                  this.sgaEmployeeInfo.employeeSalaryFrequency = this.selectedFrequency;
                  this.sgaEmployeeInfo.salaryCurrency = this.selectedCurrency;
                  this.sgaEmployeeInfo.employeeSalary = this.convertedSalary
                    ? this.convertedSalary.toString()
                    : "";
                  this.currentSga.sgaEmployeeInfo = this.sgaEmployeeInfo;
                  this.currentSga.sgaYourJob = this.sgaYourJob;
                  this.currentSga.sgaEmployeeInfo.isComplete = true;
                  if (this.currentSga.sgaEmployeeInfo.id == undefined) {
                    this.$store
                      .dispatch("sga/postsga", this.currentSga)
                      .then(() => {
                        this.$router.app.$emit("navigateToNextStep");
                      })
                      .catch(res => {
                        console.log("res", res);
                        this.modelState = res;
                        this.isLoading = false;
                      })
                      .finally(() => {
                        this.isLoading = false;
                      });
                  } else {
                    this.$store
                      .dispatch("sga/putsga", this.currentSga)
                      .then(() => {
                        this.$router.app.$emit("navigateToNextStep");
                      })
                      .catch(res => {
                        this.modelState = res;
                        this.isLoading = false;
                      })
                      .finally(() => {
                        this.isLoading = false;
                      });
                  }
                  sessionStorage.removeItem("sgaDataForPrinting");
                  sessionStorage.setItem(
                    "sgaDataForPrinting",
                    JSON.stringify({
                      page1: {
                        sgaEmployeeInfo: this.currentSga.sgaEmployeeInfo,
                        jobs: this.jobs,
                        jobTitleSelected: this.jobTitleSelected,
                        jobTitleOptions: this.jobTitleOptions,
                        jobAltTitles: this.jobAltTitles,
                        showNoData: this.showNoData,
                        selectedFrequency: this.selectedFrequency,
                        salaryFrequencies: this.salaryFrequencies,
                        base64Raw: this.base64Raw,
                        exceeded: this.exceeded
                      }
                    })
                  );
                }
              }
            });
        }
      }

      this.isLoading = false;
    },
    search() {
      if (this.keyword == "" || this.keyword == null) {
        this.$confirm("Please enter keyword to search", "Warning", {
          confirmButtonText: "OK",
          type: "warning",
          showCancelButton: false,
          dangerouslyUseHTMLString: true,
          center: true
        }).then(() => {
          return false;
        });
        return false;
      } else {
        this.isLoading = true;
        this.jobAltTitles = [];
        this.$store
          .dispatch("onet/searchCareer", this.keyword)
          .then(res => {
            res.career.forEach(element => {
              this.jobAltTitles.push({
                Code: element.code,
                Title: element.title
              });
              this.isLoading = false;
            });
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    handleSelectJobTitles() {
      this.onet.ONETCodes = [];
      this.selected_onet.ONETCodes = [];
      for (const a of document.getElementsByClassName("job-code")) {
        let lbl = a.nextElementSibling;
        let spn = a.nextElementSibling.firstElementChild;

        if (
          lbl.classList.contains("is-checked") &&
          spn.classList.contains("is-checked")
        ) {
          this.onet.ONETCodes.push(a.textContent);
        }
      }
      if (this.onet.ONETCodes.length == 0) {
        this.$confirm(`Please select atleast one job title.`, "Warning", {
          confirmButtonText: "OK",
          dangerouslyUseHTMLString: true,
          type: "warning",
          showCancelButton: false,
          center: true
        })
          .then(() => {
            return false;
          })
          .catch(() => {
            return false;
          });
      } else {
        this.getJobAlternateTitles(this.onet);
        this.selected_onet = this.onet;
        this.selected_onet_label = this.$refs.el.filter(
          x => x.$data.selfModel == true
        );
      }
    },
    getJobAlternateTitles(onetcodes) {
      this.jobAltTitles = [];
      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URI}onet/alternateTitlesByCodeV2`,
          onetcodes
        )
        .then(res => {
          this.jobAltTitles = res;

          setTimeout(() => {
            let _chkElement = document.getElementsByClassName(
              "handleAltCheckbox"
            );

            const roleTitle = this.sgaEmployeeInfo.employeeRoleTitle || "";

            let selectedtitles = roleTitle
              .split(dataDelimiter)
              .map(function(item) {
                return item.trim();
              });

            selectedtitles.forEach(element => {
              let i = this.jobAltTitles.findIndex(x => x.title == element);
              if (i > -1) _chkElement[i].__vue__._data.selfModel = true;
            });

            // //adjust the height of left listbox based on right listbox
            // let left = document.getElementById('roleTitleDiv');
            // let right = document.getElementById('officialRoleDiv');

            // if(this.onet.ONETCodes.length < 3){
            //   left.style.height = '680px';
            // }else{
            //   left.style.height = (right.offsetHeight - 15) + 'px';
            // }
          }, 500);
        });
    },
    getRoleTitleSequence(onetcodes) {
      let sequence = "";
      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URI}onet/alternateTitlesByCodeV2`,
          onetcodes
        )
        .then(res => {
          const roleTitle = this.sgaEmployeeInfo.employeeroleTitle || "";
          let alternatetitles = roleTitle.split(dataDelimiter);

          alternatetitles.forEach(element => {
            let item = res.filter(x => x.title == element.trim())[0];
            sequence += item.code + ",";
          });
          sequence = sequence.substring(0, sequence.length - 1);
          this.sgaEmployeeInfo.employeeRoleTitleCodeSequence = sequence;
        });
    },
    handelAltTitles(code, title, e) {
      for (const a of document.getElementsByClassName("title-selected")) {
        a.classList.remove("title-selected");
        a.style.backgroundColor = "";
        a.style.color = "";
      }
      e.currentTarget.classList.add("title-selected");
      e.currentTarget.style.backgroundColor = "#409EFF";
      e.currentTarget.style.color = "white";

      this.sgaEmployeeInfo.employeeRoleTitle = "";
      this.sgaEmployeeInfo.employeeRoleONETCode = "";
      this.sgaEmployeeInfo.employeeRoleTitleLevel = "";

      this.sgaEmployeeInfo.employeeRoleTitleLevel = title;
      this.sgaEmployeeInfo.employeeRoleONETCode = code;
      this.sgaEmployeeInfo.employeeRoleTitle = title;
      const a = document.getElementById("roleTitle");
      a.value = title;
    },
    handleClearTitles() {
      this.jobAltTitles = [];
      // this.sgaEmployeeInfo.EmployeeRoleTitle = '';

      this.onet.onetCodes = [];
      this.selected_onet.onetCodes = [];
      this.selected_onet_label = [];
    },
    handleClearMultiSelect() {
      this.jobTitleSelected = [];
      this.jobs.JobTitles = [];
      this.jobAltTitles = [];
      this.showNoData = true;

      this.onet.onetCodes = [];
      this.selected_onet.onetCodes = [];
      this.selected_onet_label = [];
    },
    // handleCheckbox(e, onetcode, idx) {
    //   if(!e) {
    //     let drop = this.jobAltTitles.filter(jt => jt.Code == onetcode);
    //     let _idx = 0;
    //     let _chkElement = document.getElementsByClassName('handleAltCheckbox');
    //     drop.forEach(element => {
    //       _chkElement[_idx].__vue__._data.selfModel = false;
    //       this.handleAltCheckbox(false, element.Code, element.Title);
    //       _idx++;
    //     });

    //     let temp = this.jobAltTitles.filter(jt => jt.Code != onetcode);
    //     this.jobAltTitles = [];
    //     this.jobAltTitles = temp;

    //     setTimeout(() => {
    //       let _chkElement = document.getElementsByClassName('handleAltCheckbox');
    //       let selectedtitles = this.sgaEmployeeInfo.EmployeeRoleTitle.split(",").map(function(item) {
    //         return item.trim();
    //       });

    //       let x = this.jobAltTitles;
    //       selectedtitles.forEach(element => {
    //         let i = this.jobAltTitles.findIndex(x => x.Title == element)
    //         if(i > -1) _chkElement[i].__vue__._data.selfModel = true;
    //       });
    //       this.handleSelectJobTitles();
    //     }, 100);
    //   }else{
    //     let temp = this.jobAltTitles.filter(jt => jt.Code != onetcode);
    //     this.jobAltTitles = [];
    //     this.jobAltTitles = temp;
    //     setTimeout(() => {
    //       this.onet.ONETCodes = [];
    //       // this.selected_onet.ONETCodes = [];
    //       for (const a of document.getElementsByClassName('job-code')) {
    //         let lbl = a.nextElementSibling;
    //         let spn = a.nextElementSibling.firstElementChild;

    //           if (lbl.classList.contains('is-checked') && spn.classList.contains('is-checked')) {
    //             this.onet.ONETCodes.push(a.textContent);
    //             //this.selected_onet = this.onet;
    //           }
    //       }
    //       if(this.onet.ONETCodes.length > 3){
    //         this.$confirm(`You can only select three role titles.`, 'Warning', {
    //           confirmButtonText: 'OK',
    //           dangerouslyUseHTMLString: true,
    //           type: 'warning',
    //           showCancelButton: false,
    //           center: true,
    //         }).then(() => {
    //           this.$refs.el[idx]._data.selfModel = false;
    //           this.onet.ONETCodes.splice(idx, 1);
    //           // this.selected_onet = this.onet;
    //         }).catch(() => {
    //           this.$refs.el[idx]._data.selfModel = false;
    //           this.onet.ONETCodes.splice(idx, 1);
    //           // this.selected_onet = this.onet;
    //         });
    //       }
    //     }, 100);
    //   }
    // },
    handleAltCheckbox(e, onetcode, jobtitle) {
      const delimiter = dataDelimiter;
      if (e) {
        const a = document.getElementById("roleTitle");
        let roles = a.value.split(delimiter).map(function(item) {
          return item.trim();
        });
        if (roles.length >= 3) {
          this.$confirm(`You can only select three job titles.`, "Warning", {
            confirmButtonText: "OK",
            dangerouslyUseHTMLString: true,
            type: "warning",
            showCancelButton: false,
            center: true
          })
            .then(() => {
              let x = this.$refs.AltTitle.filter(
                x => x.$el.innerText == jobtitle
              );
              x[0]._data.selfModel = false;
              return false;
            })
            .catch(() => {
              let x = this.$refs.AltTitle.filter(
                x => x.$el.innerText == jobtitle
              );
              x[0]._data.selfModel = false;
              return false;
            });
        } else {
          let idx = roles.indexOf(jobtitle);
          if (idx > -1) {
            this.$confirm(jobtitle + ` is already selected`, "Warning", {
              confirmButtonText: "OK",
              dangerouslyUseHTMLString: true,
              type: "warning",
              showCancelButton: false,
              center: true
            })
              .then(() => {
                let x = this.$refs.AltTitle.filter(
                  x => x.$el.innerText == jobtitle
                );
                x[0]._data.selfModel = false;
                return false;
              })
              .catch(() => {
                let x = this.$refs.AltTitle.filter(
                  x => x.$el.innerText == jobtitle
                );
                x[0]._data.selfModel = false;
                return false;
              });
          } else {
            this.sgaEmployeeInfo.employeeRoleTitleLevel =
              a.value == ""
                ? jobtitle
                : this.sgaEmployeeInfo.employeeRoleTitleLevel + delimiter + jobtitle;
            this.sgaEmployeeInfo.employeeRoleONETCode =
              a.value == ""
                ? onetcode
                : this.sgaEmployeeInfo.employeeRoleONETCode.indexOf(onetcode) >
                  -1
                ? this.sgaEmployeeInfo.employeeRoleONETCode
                : this.sgaEmployeeInfo.employeeRoleONETCode + ", " + onetcode;
            this.sgaEmployeeInfo.employeeRoleTitle =
              a.value == ""
                ? jobtitle
                : this.sgaEmployeeInfo.employeeRoleTitle + delimiter + jobtitle;
            this.sgaEmployeeInfo.employeeRoleTitleCodeSequence =
              a.value == ""
                ? onetcode
                : this.sgaEmployeeInfo.EmployeeRoleTitleCodeSequence +
                  ", " +
                  onetcode;
            a.value = a.value == "" ? jobtitle : a.value + delimiter + jobtitle;
            a.focus();
          }
        }
      } else {
        this.sgaEmployeeInfo.employeeRoleTitle = this.sgaEmployeeInfo.employeeRoleTitle
          .split(delimiter)
          .map(function(item) {
            return item.trim();
          });

        let idx = this.sgaEmployeeInfo.employeeRoleTitle.indexOf(jobtitle);

        if (idx > -1) {
          //remove title level by index
          let titlelevel = this.sgaEmployeeInfo.employeeRoleTitleLevel
            .split(delimiter)
            .map(function(item) {
              return item.trim();
            });
          titlelevel.splice(idx, 1);
          this.sgaEmployeeInfo.employeeRoleTitleLevel = titlelevel.join(delimiter);

          //remove title by index
          const roleTitles = this.sgaEmployeeInfo.employeeRoleTitle; //already splitted
          roleTitles.splice(idx, 1);
          this.sgaEmployeeInfo.employeeRoleTitle = roleTitles.join(delimiter);

          //remove rolecodesequence by index
          let rolecodesequence = this.sgaEmployeeInfo.employeeRoleTitleCodeSequence
            .split(",")
            .map(function(item) {
              return item.trim();
            });
          //code that needs to be removed in ONETCode
          let _codeToRemove = rolecodesequence[idx];
          rolecodesequence.splice(idx, 1);
          this.sgaEmployeeInfo.employeeRoleTitleCodeSequence = rolecodesequence.join(
            ", "
          );

          let onetcode = this.sgaEmployeeInfo.employeeRoleONETCode
            .split(",")
            .map(function(item) {
              return item.trim();
            });

          // simply distinct the rolesequence and assign value to EmployeeRoleONETCode
          let unique = [...new Set(rolecodesequence)];
          this.sgaEmployeeInfo.employeeRoleONETCode = unique.join(", ");

          const a = document.getElementById("roleTitle");
          a.value = a.value.replace(this.sgaEmployeeInfo.employeeRoleTitle);
          a.focus();

          if (this.$refs.AltTitle != null) {
            //meaning right listbox is displayed
            let x = this.$refs.AltTitle.filter(
              x => x.$el.innerText == jobtitle
            );

            //if items to be deleted is displayed in list boxes else skip
            if (x.length > 0) x[0]._data.selfModel = false;
          }
        } else {
          //rebuild the delimmited roletitle
          this.sgaEmployeeInfo.employeeRoleTitle = this.sgaEmployeeInfo.employeeRoleTitle.join(delimiter);
        }
      }

      if (
        this.sgaEmployeeInfo.employeeRoleTitle != "" &&
        this.sgaEmployeeInfo.employeeRoleTitle != null
      )
        this.roleTitles = this.sgaEmployeeInfo.employeeRoleTitle.split(delimiter);
      else this.roleTitles = [];
    },
    printPage(action) {
      this.loadPages(action);
    },
    loadPages(action) {
      this.$store.dispatch("sga/getsga").then(data => {
        this.sgaYourJob = data.sgaYourJob || this.sgaYourJob;
        this.sgaEducation = data.sgaEducation || this.sgaEducation;
        this.sgaWorkHistory = data.sgaWorkHistory || this.sgaWorkHistory;
        this.sgaCertifications =
          data.sgaCertifications || this.sgaCertifications;
        this.sgaHiddenExtras = data.sgaHiddenExtras || this.sgaHiddenExtras;
        this.sgaKnowledge = data.sgaKnowledge || this.sgaKnowledge;
        this.sgaMindset = data.sgaMindset || this.sgaMindset;
        this.sgaSkills = data.sgaSkills || this.sgaSkills;
        this.sgaHiddenTalents = data.sgaHiddenTalents || this.sgaHiddenTalents;
        this.sgaCulture = data.culture || this.sgaCulture;
        this.sgaTechnologies = data.sgaTechnologies || this.sgaTechnologies;

        this.$store
          .dispatch("sga/getSGAforPrint", this.sgaHiddenExtras)
          .then(() => {
            //this.$refs.cv.hideCV();
            this.$refs.questionnaire.showQuestionnaire();
            action();
            this.$refs.questionnaire.hideQuestionnaire();
          });
      });
    },
    printPageAsCV(action) {
      this.$confirm(`Do you want to include profile picture?`, "Warning", {
        confirmButtonText: "Yes",
        dangerouslyUseHTMLString: true,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No",
        center: true
      })
        .then(() => {
          this.$refs.cv.showCV(true);
          this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          let x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
          //this.$refs.cv.hideCV();
        })
        .catch(() => {
          this.$refs.cv.showCV(false);
          this.showProfile = false;
          this.$refs.questionnaire.hideQuestionnaire();
          let x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
        });
    },
    removePhoto() {
      this.$confirm(
        `Are you sure you want to remove your profile photo?`,
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      ).then(() => {
        this.isLoading = true;
        const selectedBucketType = this.isApprentice
          ? BucketType.Apprentice
          : BucketType.Jobseeker;
        const param = {
          objectId: this.currentUser.id,
          bucketType: selectedBucketType
        };
        this.$store.dispatch("common/removeprofileimage", param).then(() => {
          this.$message.success("Profile Image removed!.");
          this.base64Raw = "na";
          this.isLoading = false;
        });
      });
    },
    alertFunc() {
      this.isLoading = false;
      window.location.href = window.location.origin + "/sga/questionnaire/";
    }
  }
};
</script>

<style lang="scss">
#linkedin-button {
  background: #0077ba url("~../../../../assets/img/connect_w_linkedin-sm.png")
    no-repeat top left;
  background-size: 43px;
  background-position: 0% 50%;
  padding-left: 16px;
  font-family: "acumin-pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  display: inline;
}

#linkedin-button-sm {
  background: #0077ba url("~../../../../assets/img/connect_w_linkedin-sm.png")
    no-repeat top left;
  background-size: 43px;
  background-position: 50% 50%;
  padding-left: 16px;
  display: none;
}

@media screen and (max-width: 420px) {
  section {
    width: 100%;
  }

  #linkedin-button {
    display: none;
  }

  #linkedin-button-sm {
    display: inline;
  }

  .el-select-dropdown {
    // left: 0px !important;
    left: unset !important;
    width: 100% !important;
  }
}

.card-img-sga {
  display: block;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
}

.card-container-sga {
  width: 120px;
  height: 120px;
  overflow: hidden;
}

.linkedIn-btn {
  margin-bottom: 20px;
  margin-top: -30px;
}

.el-upload__input {
  display: none;
}

.el-checkbox__label {
  font-size: 15px !important;
  font-style: italic;
}

@media screen and (max-width: 759px) {
  .card-container-sga {
    width: 100% !important;
  }

  .el-select-dropdown {
    left: 15% !important;
    width: 80% !important;
  }
}
</style>
